export default "__VITE_ASSET__97z3LZfP__"